import React from 'react';
import { PickleballLanding } from './pages/PickleballLanding';
export function App() {
  return <PickleballLanding data-id="element-0" />;
}